// export const cardTypeOptions = [
//   { label: '居民身份证', value: 1 },
//   { label: '军人证件', value: 2 },
//   { label: '港澳台身份证件', value: 3 },
//   { label: '华侨身份证', value: 4 },
//   { label: '外籍护照', value: 5 },
// ]

export const initRegion = [
  { label: '全国', value: '000' },
  // { label: '浙江省', value: '330' },
  // { label: '金华市', value: '330700000000' },
  // { label: '婺城区', value: '330702000000' },
]
